import { nextTick } from "vue";

const imageSwiperMixin = {
  data() {
    return {
      swiperMounted: false,
      showButtons: false,
      numberPages: 1,
      itemsKey: 'items',
      slideNumber: 1,
      itemsPerGroup: 1,
      itemWidth: 50,
      end: 6,
      transformValue: 0,
      // start: 1,
    };
  },
  computed: {
    atStart() {
      return this.slideNumber === 1;
    },
    atEnd() {
      return this.slideNumber >= this.totalSlides;
    },
    totalSlides() {
      return this[this.itemsKey]?.length / this.itemsPerGroup;
    },
    transform() {
      return `translate3d(-${this.transformValue}px, 0, 0)`;
    },
  },
  mounted() {
    this.updateSwiper();
  },
  methods: {
    next() {
      if (this.atEnd) {
        return;
      }
      this.end += this.itemsPerGroup * 1;
      this.slideNumber += 1;
    },
    prev() {
      if (this.atStart) {
        return;
      }
      this.slideNumber -= 1;
    },
    slideNext() {
      // nextTick(() => {
      //   setTimeout(() => {
      //     this.$forceUpdate();
      //     this.mySwiper.slideNext();
      //   });
      // });
    },
    slidePrev() {
      // nextTick(() => {
      //   setTimeout(() => {
      //     this.$forceUpdate();
      //     this.mySwiper.slidePrev();
      //   });
      // });
    },
    increaseLimit() {
      if (this.$device.isDesktop) {
        return;
      }
      this.end = this[this.itemsKey]?.length ?? 0;
    },
    canShowArrows(images = [], offsetContainer = 0) {
      const elements = Array.isArray(images) && images.length ? images : this.$refs.list;
      if (this.$el && elements && elements.length && this.$refs.list && this.$refs.list.length) {
        // Is it a list of components?
        const listElement = this.$refs.list[0].$el || this.$refs.list[0];
        let colorsLengthInPx = elements.length * listElement.offsetWidth;
        colorsLengthInPx +=
          (this.$refs.list.length - 2) *
          parseFloat(window.getComputedStyle(listElement, null).getPropertyValue('margin-right'));
        // this.showButtons = colorsLengthInPx > this.$el.offsetWidth;
        this.numberPages = Math.ceil(colorsLengthInPx / (this.$el.offsetWidth - offsetContainer));
        this.showButtons = this.numberPages > 1;
      }
    },
    computeTransform(next) {
      const modulus = this[this.itemsKey]?.length % this.itemsPerGroup;
      if (this.atEnd && modulus > 0) {
        this.transformValue = this.transformValue + modulus * this.itemWidth;
      } else if (this.atStart && modulus > 0) {
        this.transformValue = this.transformValue - modulus * this.itemWidth;
      } else if (next) {
        this.transformValue = this.transformValue + this.itemsPerGroup * this.itemWidth;
      } else {
        this.transformValue = this.transformValue - this.itemsPerGroup * this.itemWidth;
      }
    },
    updateSwiper() {
      let item = this.$refs?.list?.[0];

      // component?
      if (item?.$el) {
        item = item.$el;
      }

      if (item) {
        const itemMargin = parseInt(getComputedStyle(item)?.marginRight ?? 0);

        // consider the margin.
        this.itemWidth = (item.offsetWidth || this.itemWidth) + itemMargin;

        this.itemsPerGroup = parseInt(this.$el.clientWidth / this.itemWidth);

        this.end = this.itemsPerGroup + 1;
      }

      this.swiperMounted = true;
      this.updateArrows()
    },
    updateArrows() {
      this.showButtons = (this[this.itemsKey]?.length ?? 0) > this.itemsPerGroup;
    },
  },
  watch: {
    slideNumber(newValue, oldValue) {
      this.computeTransform(newValue > oldValue);
    },
  },
};

export default imageSwiperMixin;
